//@ts-nocheck
import React from "react";
import { Typography, Button, Grid, Box, withStyles, createStyles, TextField, InputAdornment, Checkbox, IconButton } from "@material-ui/core";
import { withRouter, RouterProps } from "react-router";
import withAlertBox, { withAlertBoxProps } from "../../../../components/src/withAlertBox.Web";
import withToast, { withToastProps } from "../../../../components/src/withSnackBar.Web";
import withLoader, { withLoaderProps } from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import StorageProvider from "../../../../framework/src/StorageProvider.web";
import InputField from "../../../../components/src/InputFieldPhaseTwo.web";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import { spaceMask, mobileNumberMask } from "../masks";
import { DialogProps } from "../../../../components/src/DialogContext";
import { style } from "../Settings/Branding.web";
import PhoneNumber from "../../../../components/src/PhoneNumber.web";
import { IconPickerDialog, IconRenderer, iconPickerConfig } from "../../../../components/src/IconPicker";

export type Props = RouterProps &
  DialogProps &
  withAlertBoxProps &
  withToastProps &
  withLoaderProps & {
    id: string;
    selectedPackageList: [];
    // Customizable Area Start
    // Customizable Area End
  };

export const roadmapSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email must be in valid format").nullable(),
  firm_name: Yup.string(),
  phone_number: Yup.string()
    .matches(/^(\+\d{0,3})?(\(\d{3}\)|\d{3})[\s-]??\d{3}-??\d{4}$/, "Invalid Phone Number").nullable(),
  country_code: Yup.string(),
  web_url: Yup.string()
    .matches(/^((https?):\/\/)?([wW]{3}\.)?[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/g, "Invalid URL").nullable(),
  confidential_statement: Yup.string()
});

const swatchColors = ["#6EA6E8", "#74c283", "#f9d949", "#f59540", "#f66c6c", "#f08bb9", "#696cd4", "#f5f5f5", "#6d6d6d"];



export class RoadmapCustomization2 extends React.Component {
  formikRef: any = React.createRef();
  autoSaveInterval: any = null;
  constructor(props: Props) {
    super(props);
    this.state = {
      executionItems: [],
      noteItems: [],
      deletedNoteItems: [],
      deletedExecutionItems: [],
      customValidationErrors: []
    };
  }

  async componentDidMount() {
    const token = await StorageProvider.get("authToken");

    if(token) {
      this.props.getRoadMap();
      if (!this.props?.theme?.data && this.props.getBranding) {
        this.props.getBranding();
      }
    }
    this.autoSaveInterval = setInterval(() => {
    if (!this.formikRef.current) return;

      const { submitForm, isValid } = this.formikRef.current;

      if (isValid) {
        localStorage.setItem('isAutoSave','true')
        submitForm();
      }
    }, 20000);
  }

  setColor = () => {
    localStorage.setItem("primaryColor", this.props.primaryColor);
    localStorage.setItem("secondaryColor", this.props.secondaryColor);
  };

  validateCustomFields = (values) => {
    const errors = [];
    const checkedExecutionItems = values.executionItems.filter(item => item.checked);
    if (checkedExecutionItems.length === 0) {
      errors.push("At least one execution item must be selected");
    }
    
    const invalidExecutionItems = values.executionItems.filter(item => 
      !item.value || item.value.trim() === ''
    );
    if (invalidExecutionItems.length > 0) {
      errors.push("All execution fields must be filled");
    }

    const checkedNoteItems = values.noteItems.filter(item => item.checked);
    if (checkedNoteItems.length === 0) {
      errors.push("At least one note item must be selected");
    }

    const invalidNoteItems = values.noteItems.filter(item => 
      !item.title || item.title.trim() === '' || !item.description || item.description.trim() === ''
    );
    if (invalidNoteItems.length > 0) {
      errors.push("All note fields must be filled");
    }

    return errors;
  };

  handleSaveBranding = async (values, validateForm) => {
    const formErrors = await validateForm();
    const customErrors = this.validateCustomFields(values);
    
    if (Object.keys(formErrors).length === 0 && customErrors.length === 0) {
      this.setState({ customValidationErrors: [] });
      const processedValues = {
        ...values,
        noteItems: values.noteItems?.map(note => ({
          ...note,
          id: typeof note.id === 'string' && note.id.startsWith('fallback-') ? null : note.id
        })) || []
      };
      
      this.props.createAndUpdateBranding(processedValues);
    } else {
      this.setState({ customValidationErrors: customErrors });
    }
  };


  addExecutionItem = (setFieldValue, currentItems) => {
    const newId = Math.max(...currentItems.map(item => item.id)) + 1;
    const newItems = [...currentItems, { id: newId, value: '', checked: true }];
    setFieldValue('executionItems', newItems, false);
  };

  removeExecutionItem = (id, setFieldValue, currentItems) => {
    const itemToRemove = currentItems.find(item => item.id === id);
    const checkedItems = currentItems.filter(item => item.checked);
    
    if (itemToRemove?.checked && checkedItems.length === 1) {
      return;
    }
    
    const filteredItems = currentItems.filter(item => item.id !== id);
    setFieldValue('executionItems', filteredItems, false);
  };

  updateExecutionItem = (id, field, value, setFieldValue, currentItems) => {
    if (field === 'checked' && value === false) {
      const checkedItems = currentItems.filter(item => item.checked);
      if (checkedItems.length === 1 && checkedItems[0].id === id) {
        return;
      }
    }

    const updatedItems = currentItems.map(item =>
      item.id === id ? { ...item, [field]: value } : item
    );
    setFieldValue('executionItems', updatedItems, false);
    this.setState({ customValidationErrors: [] });
  };

  updateNoteItem = (id, field, value, setFieldValue, currentItems) => {
    if (field === 'checked' && value === false) {
      const checkedItems = currentItems.filter(item => item.checked);
      if (checkedItems.length === 1 && checkedItems[0].id === id) {
        return;
      }
    }

    const updatedItems = currentItems.map(item =>
      item.id === id ? { ...item, [field]: value } : item
    );
    setFieldValue('noteItems', updatedItems, false);
    this.setState({ customValidationErrors: [] });
  };

  handleIconSelect = (id, iconName, setFieldValue, currentItems) => {
    const updatedItems = currentItems.map(item =>
      item.id === id ? { ...item, icon: iconName } : item
    );
    setFieldValue('noteItems', updatedItems, false);
  };

  getExecutionItemsAsObject = () => {
    return {
      "0": {
        "text": "We will work with you to define & prioritize work items based on your goals.",
        "is_checked": true
      },
      "1": {
        "text": "We will execute as many work items as are feasible for the engagement period & package chosen.",
        "is_checked": true
      },
      "2": {
        "text": "As work items are completed, we will update and re-prioritize action items to ensure our efforts are always focused on your immediate needs.",
        "is_checked": true
      }
    };
  };

  getExecutionItems = () => {
    if (this.props?.roadMap?.attributes?.executions && Object.keys(this.props.roadMap.attributes.executions).length > 0) {
      return Object.values(this.props.roadMap.attributes.executions).map((execution, index) => ({
        id: index + 1,
        value: typeof execution === 'string' ? execution : execution.text,
        checked: typeof execution === 'string' ? true : execution.is_checked === true || execution.is_checked === 'true'
      }));
    }
    else if (this.props?.theme?.data?.attributes?.executions && Object.keys(this.props.theme.data.attributes.executions).length > 0) {
      return Object.values(this.props.theme.data.attributes.executions).map((execution, index) => ({
        id: index + 1,
        value: typeof execution === 'string' ? execution : execution.text,
        checked: typeof execution === 'string' ? true : execution.is_checked === true || execution.is_checked === 'true'
      }));
    } else {
      const fallbackExecutions = this.getExecutionItemsAsObject();
      return Object.values(fallbackExecutions).map((execution, index) => ({
        id: index + 1,
        value: typeof execution === 'string' ? execution : execution.text,
        checked: typeof execution === 'string' ? true : execution.is_checked === true || execution.is_checked === 'true'
      }));
    }
  };

  getNoteItems = () => {
    if (this.props?.roadMap?.attributes?.notes?.data?.length > 0) {
      return this.props.roadMap.attributes.notes.data.map((note, index) => ({
        id: note.id || index + 1,
        title: note.attributes.title || '',
        description: note.attributes.description || '',
        icon: note.attributes.icon || 'Star',
        checked: note.attributes.is_checked !== undefined ? note.attributes.is_checked : true
      }));
    }
    else if (this.props?.theme?.data?.attributes?.notes?.data?.length > 0) {
      return this.props.theme.data.attributes.notes.data.map((note, index) => ({
        id: note.id || index + 1,
        title: note.attributes.title || '',
        description: note.attributes.description || '',
        icon: note.attributes.icon || 'Star',
        checked: note.attributes.is_checked !== undefined ? note.attributes.is_checked : true
      }));
    } else {
      return [
        {
          id: 'fallback-1',
          title: "Decision",
          description: "Choose the option that best fits your needs.",
          icon: "Check",
          checked: true
        },
        {
          id: 'fallback-2',
          title: "Onboarding",
          description: "eSign your enrollment documents, make your payment, & we will designate resources for your work.",
          icon: "Briefcase",
          checked: true
        },
        {
          id: 'fallback-3',
          title: "Kickoff Call",
          description: "We can schedule a kickoff call to get started!",
          icon: "Phone",
          checked: true
        }
      ];
    }
  };


  removeNoteItem = (id, setFieldValue, currentItems) => {
    const itemToRemove = currentItems.find(item => item.id === id);
    const checkedItems = currentItems.filter(item => item.checked);
    
    if (itemToRemove?.checked && checkedItems.length === 1) {
      return;
    }
    
    const updatedItems = currentItems.map(item =>
      item.id === id ? { ...item, _destroy: 1 } : item
    ).filter(item => item._destroy !== 1);
    
    const deletedItem = { ...itemToRemove, _destroy: 1 };
    const deletedItems = this.state.deletedNoteItems || [];
    this.setState({ deletedNoteItems: [...deletedItems, deletedItem] });
    
    setFieldValue('noteItems', updatedItems, false);
  };

  render() {
    const { classes } = this.props;
    return (
      <Formik
      innerRef={this.formikRef}
        initialValues={{
          email: this.props?.email || "",
          firm_name: this.props?.firm_name,
          phone_number:
            this.props?.phone_number === "null" ||
            this.props?.phone_number === null ||
            this.props?.phone_number === undefined
              ? ""
              : this.props?.phone_number,
          web_url: this.props?.web_url,
          country_code: this.props?.country_code ||'+1',
          confidential_statement: this.props.confidential_statement || "This has been prepared for the purpose of providing tax, accounting and strategic advisory services. This information should not be shared, has not been audited, and does not imply we're providing investment advice.",
          executionItems: this.getExecutionItems(),
          noteItems: this.getNoteItems()
        }}
        validationSchema={roadmapSchema}
        enableReinitialize
        onSubmit={(values) => {
          const customErrors = this.validateCustomFields(values);
          if (customErrors.length === 0) {
            this.setState({ customValidationErrors: [] });
            this.setColor();
            const allNoteItems = [...values.noteItems, ...(this.state.deletedNoteItems || [])];
            const valuesWithDeleted = { ...values, noteItems: allNoteItems };
            this.props.updateRoadMap(valuesWithDeleted);
          } else {
            this.setState({ customValidationErrors: customErrors });
          }
        }}
      >
        {(formikProps) => {
          const { values, handleChange, isValid, setFieldValue, errors, touched, setFieldTouched, validateForm } = formikProps;
          return (
            <Form autoComplete="off" noValidate>
              <Grid container spacing={6} justifyContent="space-between">
                <Grid item xs={12}>
                  <Typography className={classes.title}>Roadmap Customization</Typography>
                  <Typography className={classes.subTitle}>Update your logo, colors, and contact information below.</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" className={classes.customLabel}>
                    Add Logo
                  </Typography>
                  {this.props.showCorrectImage()}
                </Grid>
                <Grid item md={6} />
                <Grid item md={5} xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography className={classes.customLabel}>Add Primary Color</Typography>
                      <Grid container className={classes.whiteCard}>
                        <Typography className={classes.swatchTitle}>PICK A SWATCH:</Typography>
                        <Grid item xs={12}>
                          {swatchColors.map((color) => {
                            return (
                              <Box
                                key={color}
                                className={classes.colorSwatch}
                                onClick={() => this.props.handlePrimaryColorChange(color)}
                                style={{
                                  backgroundColor: color,
                                }}
                              />
                            );
                          })}
                        </Grid>
                        <TextField
                          variant="outlined"
                          name="primaryColor"
                          value={this.props.primaryColor}
                          onChange={this.props.handleColorInputChange}
                          placeholder="Enter Hex Code"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <FiberManualRecordIcon
                                  style={{
                                    fill: this.props.primaryColor,
                                  }}
                                  size="small"
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={5} xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography className={classes.customLabel}>Add Secondary Color</Typography>
                      <Grid container className={classes.whiteCard}>
                        <Typography className={classes.swatchTitle}>PICK A SWATCH:</Typography>
                        <Grid item xs={12}>
                          {swatchColors.map((color) => {
                            return (
                              <Box
                                key={color}
                                className={classes.colorSwatch}
                                onClick={() => this.props.handleSecondaryColorChange(color)}
                                style={{
                                  backgroundColor: color,
                                }}
                              />
                            );
                          })}
                        </Grid>
                        <TextField
                          variant="outlined"
                          name="secondaryColor"
                          value={this.props.secondaryColor}
                          onChange={this.props.handleColorInputChange}
                          placeholder="Enter Hex Code"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <FiberManualRecordIcon
                                  style={{
                                    fill: this.props.secondaryColor,
                                  }}
                                  size="small"
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={5} xs={12}>
                  <Field
                    component={InputField}
                    name="firm_name"
                    onChange={(e) => handleChange(spaceMask(e))}
                    value={values.firm_name}
                    fullWidth
                    label="Firm Name"
                    InputProps={{
                      inputProps: {
                        maxlength: "20",
                      },
                    }}
                  />
                </Grid>
                <Grid item md={5} xs={12}>
                  <Field component={InputField} name="email" onChange={(e) => handleChange(spaceMask(e))} value={values.email} fullWidth label="Firm Email" />
                </Grid>
                <Grid item md={5} xs={12}>
                  <Field name="phone_number"
                    fullWidth
                    label="Firm Phone Numbere">
                    {({ field, form }: any) => (
                    <PhoneNumber
                        countryCode={form.values.country_code}
                        phoneNumber={form.values.phone_number}
                        onChange={(code, number) => {
                          form.setFieldValue("country_code", code);
                          form.setFieldValue("phone_number", number);
                        }}
                        label="Firm Phone Number"
                      />
                      )}
                  </Field>
                </Grid>
                <Grid item md={5} xs={12}>
                  <Field
                    component={InputField}
                    name="web_url"
                    onChange={(e) => handleChange(spaceMask(e))}
                    value={values.web_url}
                    fullWidth
                    label="Firm Web URL"
                  />
                </Grid>

                {/* Execution */}
                <Grid item xs={12} >
                  <Box display="flex" alignItems="center">
                    <Typography variant="subtitle2" className={classes.customLabel}>
                      Add Execution
                    </Typography>
                  </Box>
                  {values.executionItems.map((item, index) => (
                    <Box key={item.id} display="flex" alignItems="center" mt={index === 0 ? 1 : "28px"}>
                      <Checkbox
                        color="primary"
                        style={{ padding: '4px 0', marginRight : "15px" }}
                        checked={item.checked}
                        onChange={(e) => {
                          if (!e.target.checked) {
                            const checkedItems = values.executionItems.filter(execItem => execItem.checked);
                            if (checkedItems.length === 1 && checkedItems[0].id === item.id) {
                              return;
                            }
                          }
                          
                          const updatedItems = values.executionItems.map(execItem =>
                            execItem.id === item.id ? { ...execItem, checked: e.target.checked } : execItem
                          );
                          setFieldValue('executionItems', updatedItems, false);
                          setFieldTouched('executionItems', true, false);
                          this.setState({ customValidationErrors: [] });
                        }}
                      />
                      <TextField
                        variant="outlined"
                        value={item.value}
                        onChange={(e) => {
                          this.updateExecutionItem(item.id, 'value', e.target.value, setFieldValue, values.executionItems);
                          setFieldTouched('executionItems', true, false);
                        }}
                        fullWidth
                        placeholder="Enter execution item"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                edge="end"
                                onClick={() => {
                                  this.updateExecutionItem(item.id, 'value', '', setFieldValue, values.executionItems);
                                  setFieldTouched('executionItems', true, false);
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  ))}
                  {errors.executionItems && touched.executionItems && (
                    <Box mt={2}>
                      <Typography variant="body2" color="error">
                        {errors.executionItems}
                      </Typography>
                    </Box>
                  )}
                </Grid>


                {/* Note */}
                <Grid item xs={12} >
                  <Box display="flex" alignItems="center" mt={3}>
                    <Typography variant="subtitle2" className={classes.customLabel}>
                      Add Note
                    </Typography>
                  </Box>
                  {values.noteItems.map((item, index) => (
                    <Box key={item.id} mt={index === 0 ? 2 : "33px"} position="relative">
                      <Box display="flex" alignItems="center" gap={3}>
                        <Checkbox
                          color="primary"
                          style={{ marginTop: '8px', marginRight : "15px" }}
                          checked={item.checked}
                          onChange={(e) => {
                            if (!e.target.checked) {
                              const checkedItems = values.noteItems.filter(noteItem => noteItem.checked);
                              if (checkedItems.length === 1 && checkedItems[0].id === item.id) {
                                return;
                              }
                            }
                            
                            const updatedItems = values.noteItems.map(noteItem =>
                              noteItem.id === item.id ? { ...noteItem, checked: e.target.checked } : noteItem
                            );
                            setFieldValue('noteItems', updatedItems, false);
                            setFieldTouched('noteItems', true, false);
                            this.setState({ customValidationErrors: [] });
                          }}
                        />
                        <Box display="flex" flexDirection="column" alignItems="center">
                          <Box 
                            style={{ 
                              width: '130px',
                              height: '130px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: '2px dashed #ddd',
                              borderRadius: '8px',
                              backgroundColor: '#f9f9f9',
                           
                              position: 'relative',
                              cursor: 'pointer'
                            }}
                          >
                            {item.icon ? (
                              <IconRenderer 
                                icon={item.icon} 
                                style={{ width: '32px', height: '32px', color: '#666' }} 
                              />
                            ) : (
                              <EditIcon style={{ color: '#999', fontSize: '32px' }} />
                            )}
                            <IconPickerDialog
                              selected={item.icon}
                              onChange={(iconName) => this.handleIconSelect(item.id, iconName, setFieldValue, values.noteItems)}
                              buttonText=""
                              dialogTitle={iconPickerConfig.dialogTitle}
                              dialogDescription={iconPickerConfig.dialogDescription}
                              renderTrigger={(onClick) => (
                                <IconButton
                                  size="small"
                                  onClick={onClick}
                                  style={{
                                    position: 'absolute',
                                    bottom: '2px',
                                    right: '2px',
                                    width: '25px',
                                    height: '25px',
                                   
                                    borderRadius: '4px'
                                  }}
                                >
                                  <EditIcon style={{ fontSize: '12px', color: '#666' }} />
                                </IconButton>
                              )}
                            />
                          </Box>
                        </Box>
                        <Box display="flex" flexDirection="column" gap={3} flex={1} ml={2}>
                          <TextField
                            variant="outlined"
                            value={item.title}
                            onChange={(e) => {
                              this.updateNoteItem(item.id, 'title', e.target.value, setFieldValue, values.noteItems);
                              setFieldTouched('noteItems', true, false);
                            }}
                            fullWidth
                            placeholder="Title"
                            size="small"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    edge="end"
                                    onClick={() => {
                                      this.updateNoteItem(item.id, 'title', '', setFieldValue, values.noteItems);
                                      setFieldTouched('noteItems', true, false);
                                    }}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <Box mt={2}>
                            <TextField
                              variant="outlined"
                              value={item.description}
                              onChange={(e) => {
                                this.updateNoteItem(item.id, 'description', e.target.value, setFieldValue, values.noteItems);
                                setFieldTouched('noteItems', true, false);
                              }}
                              fullWidth
                              placeholder="Description"
                              multiline
                              rows={2}
                              size="small"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      size="small"
                                      edge="end"
                                      onClick={() => {
                                        this.updateNoteItem(item.id, 'description', '', setFieldValue, values.noteItems);
                                        setFieldTouched('noteItems', true, false);
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                  {errors.noteItems && touched.noteItems && (
                    <Box mt={2}>
                      <Typography variant="body2" color="error">
                        {errors.noteItems}
                      </Typography>
                    </Box>
                  )}
                  {this.state.customValidationErrors.length > 0 && (
                    <Box mt={2}>
                      {this.state.customValidationErrors.map((error, index) => (
                        <Typography key={index} variant="body2" color="error" style={{ marginBottom: '0.5rem' }}>
                          {error}
                        </Typography>
                      ))}
                    </Box>
                  )}
                </Grid>


                <Grid  item md={5} xs={12}>
                  <Field
                    component={InputField}
                    name="confidential_statement"
                    onChange={(e) => handleChange(spaceMask(e))}
                    value={values.confidential_statement}
                    fullWidth
                    label="Confidentiality & Disclaimer"
                    multiline
                    minRows={4}
                  />
                </Grid>
                <Grid item xs={12} className={classes.bottomSection}>
                  <Grid container direction="row" justifyContent="flex-end" spacing={2}>
                    <Grid item md={4} xs={6} container justifyContent="flex-end">
                      <Button
                        color="primary"
                        disabled={!isValid}
                        onClick={this.handleSaveBranding.bind(this, values, validateForm)}
                        variant="outlined"
                      >
                        Save to Profile
                      </Button>
                    </Grid>
                    <Grid item md={2} xs={6} container justifyContent="flex-end">
                      <Button
                        type="submit"
                        color="primary"
                        disabled={!isValid}
                        variant="contained"
                        onClick={()=>localStorage.removeItem('isAutoSave')}
                      >
                        Save & continue
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const RoadmapCustomization2WithRouter = withRouter(RoadmapCustomization2);
const RoadmapCustomization2AlertBox = withAlertBox(RoadmapCustomization2WithRouter);
const RoadmapCustomization2Loader = withLoader(RoadmapCustomization2AlertBox);
const RoadmapCustomization2Toast = withToast(RoadmapCustomization2Loader);
const RoadmapCustomization2WithDialog = withDialog(RoadmapCustomization2Toast);

export const RoadmapCustomization2WithStyles = withStyles((theme) =>
  createStyles({
    ...style(theme)
  })
)(withConfirmBox(RoadmapCustomization2WithDialog));

export default RoadmapCustomization2WithStyles;